import Drawing from './Drawing';

const NotFound = () => {
    return (
        <Drawing path="NotFound.svg" maxWidth='300px' />
    );
}

export default NotFound;